import { createFileRoute } from '@tanstack/react-router'

import { DocumentPage } from '@/components/documents/document-page'
import { useFollowClient } from '@/lib/current-client'
import { RETURN_SHAPE } from '@/lib/return-to'
import { readSearch, text } from '@/lib/search-params'

export const Route = createFileRoute('/_app/clients/$clientId_/documents/$documentId')({
  validateSearch: (search: Record<string, unknown>) =>
    readSearch(
      {
        /** Venu de l'onglet Documents d'un projet (1.33.0) : sa référence, pour y rattacher et y revenir. */
        projet: text(),
        ...RETURN_SHAPE,
      },
      search,
    ),
  component: MarkdownDocumentPage,
})

function MarkdownDocumentPage() {
  const { clientId, documentId } = Route.useParams()
  useFollowClient(clientId)
  const { projet } = Route.useSearch()
  return <DocumentPage clientId={clientId} documentId={documentId} projectRef={projet} />
}
